import { Injectable } from '@angular/core';
import {
  AbstractJobCreatorResolverService,
  JobTriggeredBy,
  JobTriggeredByOrchestration,
  TriggeredByType,
} from '@y42/job';
import { OrchestrationRunDetailsDialogService } from '../orchestration/components/orchestration-run-details/orchestration-run-details-dialog/orchestration-run-details-dialog.service';

@Injectable()
export class JobCreatorResolverService implements AbstractJobCreatorResolverService {
  constructor(private readonly orchestrationRunDetailsDialogService: OrchestrationRunDetailsDialogService) {}

  canResolve(triggeredBy: JobTriggeredBy): triggeredBy is JobTriggeredByOrchestration {
    return triggeredBy.type === TriggeredByType.Orchestration && !!triggeredBy.data;
  }

  resolve(triggeredBy: JobTriggeredBy): void {
    if (this.canResolve(triggeredBy)) {
      this.orchestrationRunDetailsDialogService.openDialog(triggeredBy.data);
    }
  }
}
